<template>
    <select class="form-control" id="statelist" placeholder="State" @change="handleChange">
        <option data-country="36" value="Austl. Cap. Terr.">Austl. Cap. Terr.</option>
        <option data-country="36" value="New South Wales">New South Wales</option>
        <option data-country="36" value="Northern Territory">Northern Territory</option>
        <option data-country="36" value="Queensland">Queensland</option>
        <option data-country="36" value="South Australia">South Australia</option>
        <option data-country="36" value="Tasmania">Tasmania</option>
        <option data-country="36" value="Victoria">Victoria</option>
        <option data-country="36" value="Western Australia">Western Australia</option>
    </select>
</template>

<script>
export default {
methods: {
    handleChange (e) {
      // Set Regus State.
      if(e.target.options.selectedIndex > -1) {
        let regusState = e.target.value;
        this.$store.commit('setRegusState', regusState);
      }
    }
  }
}
</script>

<style>

</style>
